// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { doNotForwardProps } from "metabase/common/utils/doNotForwardProps";
import { breakpointMinExtraLarge } from "metabase/styled-components/theme";
import { Title } from "metabase/ui";
import { color } from "metabase/ui/utils/colors";

interface CaptionProps {
  primary?: boolean;
}

// Renders as a real <h2> (via Title) instead of a plain <div> styled to
// merely look like a heading — these captions ("Pick up where you left
// off", "Here are some popular dashboards", etc.) are section headings,
// not decoration. `primary` is a style-only prop (unlike a plain
// styled.div, styled(Component) forwards unknown props all the way to
// the DOM by default), so it's excluded from forwarding here.
export const CaptionRoot = styled(
  Title,
  doNotForwardProps("primary"),
)<CaptionProps>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.primary ? color("text-primary") : color("text-secondary")};
  font-weight: bold;
  margin-bottom: 1.5rem;

  ${breakpointMinExtraLarge} {
    margin-bottom: 2rem;
  }
`;
